module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messaging-link-generator"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('label', {
    staticClass: "section-label required"
  }, [_vm._v("Platform")]), _vm._v(" "), _c('div', {
    staticClass: "platform-cards"
  }, [_c('div', {
    staticClass: "platform-card",
    class: {
      active: _vm.selectedPlatform === 'whatsapp'
    },
    on: {
      "click": function($event) {
        return _vm.selectPlatform('whatsapp')
      }
    }
  }, [(_vm.selectedPlatform === 'whatsapp') ? _c('div', {
    staticClass: "platform-check"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "platform-name"
  }, [_vm._v("WhatsApp")]), _vm._v(" "), _c('div', {
    staticClass: "platform-sub"
  }, [_vm._v("wa.me link")])]), _vm._v(" "), _c('div', {
    staticClass: "platform-card",
    class: {
      active: _vm.selectedPlatform === 'messenger'
    },
    on: {
      "click": function($event) {
        return _vm.selectPlatform('messenger')
      }
    }
  }, [(_vm.selectedPlatform === 'messenger') ? _c('div', {
    staticClass: "platform-check"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "platform-name"
  }, [_vm._v("Messenger")]), _vm._v(" "), _c('div', {
    staticClass: "platform-sub"
  }, [_vm._v("m.me link")])]), _vm._v(" "), _c('div', {
    staticClass: "platform-card",
    class: {
      active: _vm.selectedPlatform === 'line'
    },
    on: {
      "click": function($event) {
        return _vm.selectPlatform('line')
      }
    }
  }, [(_vm.selectedPlatform === 'line') ? _c('div', {
    staticClass: "platform-check"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "platform-name"
  }, [_vm._v("Line")]), _vm._v(" "), _c('div', {
    staticClass: "platform-sub"
  }, [_vm._v("line.me link")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "field-label required"
  }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    on: {
      "change": _vm.onCountryChange
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Select Country --")]), _vm._v(" "), _vm._l((_vm.availableCountries), function(country) {
    return _c('option', {
      key: country,
      domProps: {
        "value": country
      }
    }, [_vm._v("\n              " + _vm._s(country) + "\n            ")])
  })], 2), _vm._v(" "), (_vm.selectedCountry && _vm.selectedPlatform === 'whatsapp') ? _c('small', {
    staticClass: "helper-text"
  }, [_vm._v("\n            WhatsApp Business number for " + _vm._s(_vm.selectedCountry) + "\n          ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Mapped Number / ID")]), _vm._v(" "), _c('input', {
    staticClass: "form-control mapped-input",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "Select a country"
    },
    domProps: {
      "value": _vm.mappedId
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "helper-text"
  }, [_vm._v("Pulled from system configuration")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "message-tabs"
  }, [_c('button', {
    staticClass: "msg-tab-btn",
    class: {
      active: _vm.messageType === 'keyword'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.switchMessageType('keyword')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Keyword")]), _vm._v(" "), _c('button', {
    staticClass: "msg-tab-btn",
    class: {
      active: _vm.messageType === 'phrase'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.switchMessageType('phrase')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  }), _vm._v(" Phrase")]), _vm._v(" "), _c('button', {
    staticClass: "msg-tab-btn",
    class: {
      active: _vm.messageType === 'custom'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.switchMessageType('custom')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Custom Text")])]), _vm._v(" "), _c('div', {
    staticClass: "message-input-area"
  }, [(_vm.messageType === 'keyword') ? _c('div', [_c('treeselect', {
    attrs: {
      "options": _vm.filteredKeywordOptions,
      "clearable": true,
      "searchable": true,
      "disabled": !_vm.selectedCountry,
      "placeholder": "-- Search & select a keyword --"
    },
    model: {
      value: (_vm.selectedKeyword),
      callback: function($$v) {
        _vm.selectedKeyword = $$v
      },
      expression: "selectedKeyword"
    }
  }), _vm._v(" "), (!_vm.selectedCountry) ? _c('small', {
    staticClass: "helper-text"
  }, [_vm._v("Select a country first")]) : (_vm.filteredKeywordOptions.length === 0) ? _c('small', {
    staticClass: "helper-text helper-warning"
  }, [_vm._v("No keywords found for " + _vm._s(_vm.selectedCountry))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.messageType === 'phrase') ? _c('div', [_c('treeselect', {
    attrs: {
      "options": _vm.phraseOptions,
      "clearable": true,
      "searchable": true,
      "disabled": !_vm.selectedCountry,
      "placeholder": "-- Search & select a phrase --"
    },
    model: {
      value: (_vm.selectedPhrase),
      callback: function($$v) {
        _vm.selectedPhrase = $$v
      },
      expression: "selectedPhrase"
    }
  }), _vm._v(" "), (!_vm.selectedCountry) ? _c('small', {
    staticClass: "helper-text"
  }, [_vm._v("Select a country first")]) : (_vm.phraseOptions.length === 0 && !_vm.loadingPhrases) ? _c('small', {
    staticClass: "helper-text helper-warning"
  }, [_vm._v("No phrases found for " + _vm._s(_vm.selectedCountry))]) : _vm._e(), _vm._v(" "), (_vm.loadingPhrases) ? _c('small', {
    staticClass: "helper-text"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading phrases...")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.messageType === 'custom') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customText),
      expression: "customText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter custom pre-filled text..."
    },
    domProps: {
      "value": (_vm.customText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customText = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.generatedLink) ? _c('div', {
    staticClass: "section generated-section"
  }, [_c('label', {
    staticClass: "section-label generated-label"
  }, [_vm._v("GENERATED LINK")]), _vm._v(" "), _c('div', {
    staticClass: "generated-link-row"
  }, [_c('div', {
    staticClass: "link-display"
  }, [_c('i', {
    staticClass: "fa fa-link link-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.generatedLink))])]), _vm._v(" "), _c('div', {
    staticClass: "link-actions"
  }, [_c('button', {
    staticClass: "btn btn-action btn-copy",
    attrs: {
      "title": "Copy to clipboard"
    },
    on: {
      "click": _vm.copyLink
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  }), _vm._v(" Copy\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-action btn-qr",
    class: {
      'btn-qr-active': _vm.showQr
    },
    attrs: {
      "title": "Generate QR Code"
    },
    on: {
      "click": _vm.toggleQr
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" QR\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-action btn-visit",
    attrs: {
      "title": "Open link in new tab"
    },
    on: {
      "click": _vm.visitLink
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" Visit Link\n        ")])])]), _vm._v(" "), (_vm.showQr) ? _c('div', {
    staticClass: "qr-section"
  }, [_c('div', {
    staticClass: "qr-container"
  }, [_vm._m(5), _vm._v(" "), (_vm.qrPreviewUrl) ? _c('img', {
    staticClass: "qr-image",
    attrs: {
      "src": _vm.qrPreviewUrl,
      "alt": "QR Code"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qr-link-text"
  }, [_vm._v(_vm._s(_vm.generatedLink))]), _vm._v(" "), _c('div', {
    staticClass: "qr-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.downloadQr
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download QR (1024 x 1024)\n          ")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedCountry && _vm.mappedId && !_vm.generatedLink) ? _c('div', {
    staticClass: "section empty-state"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-banner"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n    Quickly generate deep links for WhatsApp, Messenger, or Line. Links are not saved — copy them to use in campaigns, nudges, or external channels.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "platform-icon whatsapp-icon"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "platform-icon messenger-icon"
  }, [_c('i', {
    staticClass: "fa fa-facebook-official"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "platform-icon line-icon"
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "section-label"
  }, [_vm._v("Pre-filled Message "), _c('span', {
    staticClass: "optional-tag"
  }, [_vm._v("(optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-header"
  }, [_c('span', {
    staticClass: "qr-title"
  }, [_vm._v("QR Code Preview")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-state-content"
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v(" "), _c('p', [_vm._v("Select a keyword, phrase, or enter custom text to generate a link — or your link will appear here once a country is selected.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-80af6ab4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/link-management/MessagingLinkGenerator.vue
// module id = nwcW
// module chunks = 1